import React from 'react';
import { AppBundle } from 'api/optimalprint-sdk.d';
import exploreOptions, { ExtendedProductPageSelectorOption } from 'utils/attributes/exploreOptions';
import ProductAttributeColorSelector from './ProductAttributeColorSelector/ProductAttributeColorSelector';
import ProductAttributeSimpleSelector from './ProductAttributeSimpleSelector/ProductAttributeSimpleSelector';
import ProductAttributeDropdownSelectorPremium from './ProductAttributeDropdownSelectorPremium/ProductAttributeDropdownSelectorPremium';

export interface ProductAttributeSelectorWithouCallbackProps {
  selector: AppBundle.Api.Entity.Design.V1.DesignAbstractProduct.ProductPageSelector;
  options: ExtendedProductPageSelectorOption[];
  changeAttribute?: (typeName: string, value: string, defaultProductId: number) => void;
}

export type ProductAttributeSelectorProps = ProductAttributeSelectorWithouCallbackProps & {
  onClick: (typeName: string, value: string, defatultProductId: number) => void;
};

const ProductAttributeSelector = ({
  selector,
  options,
  changeAttribute,
}: ProductAttributeSelectorWithouCallbackProps) => {
  const optionInfo = exploreOptions(options);

  if (!changeAttribute) {
    return null;
  }

  if (optionInfo.hasColorOptions) {
    return <ProductAttributeColorSelector selector={selector} options={options} onClick={changeAttribute} />;
  }

  if (optionInfo.totalOptions > 0) {
    return <ProductAttributeDropdownSelectorPremium selector={selector} options={options} onClick={changeAttribute} />;
  }
  return <ProductAttributeSimpleSelector selector={selector} options={options} onClick={changeAttribute} />;
};

export default ProductAttributeSelector;
